import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';

export const CmsReactionsLoadable = clientOnlyLazy({
  loader: () =>
    import('./CmsReactions').then((resolved) => ({
      default: resolved.CmsReactions,
    })),
});
